export default __webpack_public_path__ + "static/media/icon-setting.52839427.svg";